module.exports = __webpack_public_path__ + "static/media/ahora20mg.4f581b42.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/img-on-alambrico/ahora20mg.png
// module id = 193
// module chunks = 0